import { Component, OnInit } from '@angular/core';
import { SidebarComponent, MenuComponent, NavbarComponent } from '../shared/index-shared.component';
import { StorageService,UsuariosService } from '../../servicios/index.service';
import { Observable } from 'rxjs/Observable';
declare var $;

@Component({
  selector: 'app-servicios',
  templateUrl: './servicios.component.html',
  styles: []
})
export class ServiciosComponent implements OnInit {

  tabla_serv:any;
  gif:boolean = true;
  registros:any;

  constructor(private storage:StorageService, private _us:UsuariosService) {
    document.getElementById('body').className = 'hold-transition skin-blue sidebar-mini sidebar-collapse';
  }

  ngOnInit() {
    $(document).ready(function() {
      $("body").css("overflow","auto");
    });
    this.tablaServicios();
  }
  ngOnDestroy(){
    this.registros.unsubscribe();
  }

  tablaServicios(){
    this.registros = this._us.cosnulta_serv().map(res=>res).subscribe(data=>{
      this.tabla_serv = data;
      if(this.tabla_serv){
        this.settime();
        console.log("Se cargo");
        this.gif = false;
        $("#example2").removeAttr("#example2");
      }else{
        alert("Error al cargar datos");
      }
    });
  }

  settime(){
    setTimeout(function(){
      $(function () {
        $("#example1").DataTable();
        $('#example2').DataTable({
          "paging": true,
          "lengthChange": false,
          "searching": false,
          "ordering": true,
          "info": true,
          "autoWidth": false,
          "order": [[ 0, 'desc' ]]
        });
      });
    },1500);
  }

  elimina_serv( id:string ){
    let  txt;
    let res = confirm("Estas seguro que deseas eliminar el servivio con id:"+id);
    if(res == true){
      this._us.delete_ser(id).then(()=>{
        $.notify({
          icon: 'fa fa-dot-circle-o',
          title:"<b>Se eliminó servicio</b><br>",
          message:"El servicio <b>" +id + "</b> fué eliminado correctamente"
        });
      });
    }
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/components/servicios/servicios.component.ts